// @core/api/endpoints/booking/list_resource_reviews.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListReviewsResponse,
} from '../../../types/booking';

const BASE_PATH = '/booking';

/**
 * List resource reviews
 * Returns reviews for a bookable resource with rating breakdown.
 */
export async function ListResourceReviews(
  resource_id: string,
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    limit?: string | number | boolean;
    min_rating?: string | number | boolean;
    sort?: string | number | boolean;
    sort_by?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListReviewsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/resources/:resource_id/reviews`;
  requestPath = requestPath.replace(':resource_id', encodeURIComponent(resource_id));
  const requestOptions = options;
  return client.get<ListReviewsResponse>(requestPath, { ...requestOptions, params });
}
